import { findNodeById } from '__mocks__/helpers/find'
import timelines from '../fixtures/timelines.json'
import paginate from '../helpers/paginate'
import { TResponseResolver } from '../types'

const delay = 800

export const mockReadTimeline: TResponseResolver = async (req, res, ctx) => {
  const qs = req.url.searchParams
  const id = qs.get('id')
  const page = qs.get('page')
  const per_page = qs.get('per_page')
  return res(
    paginate({ page, per_page }),
    findNodeById(id as string),
    ctx.delay(delay),
    ctx.status(200),
    ctx.json(timelines)
  )
}
